import { render, staticRenderFns } from "./GalleryModal.vue?vue&type=template&id=5e4c56fd"
import script from "./GalleryModal.vue?vue&type=script&lang=js"
export * from "./GalleryModal.vue?vue&type=script&lang=js"
import style0 from "./GalleryModal.vue?vue&type=style&index=0&id=5e4c56fd&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports